import { HeadData } from '@/components/HeadData';
import { graphql } from '@/gql/codegen/gql';
import { TermsOfUseAgreementStateEnum } from '@/gql/codegen/graphql';
import { useSuspenseQuery } from '@apollo/client';
import { Navigate, createFileRoute } from '@tanstack/react-router';
import { TermsOfServiceContainer } from './-container';
import { useAgreeTermOfUse } from './-hooks/useAgreeTermOfUse';

type TermsOfServiceSearch = {
  redirectTo: string;
};

export const Route = createFileRoute('/_gloplaUserLayout/terms-of-service/')({
  component: component,
  validateSearch: (search: Record<string, unknown>): TermsOfServiceSearch => {
    // validate and parse the search params into a typed state
    return {
      redirectTo: (search.redirectTo as string) || '/',
    };
  },
});

// agreementStateはリダイレクト処理のためこのcomponentでも利用
export const GET_TERMS_OF_USE = graphql(/* GraphQL */ `
  query TermsOfServicePageQuery {
    embaTermsOfUse {
      agreementState
      ...TemsOfUseItem
    }
  }
`);

function component() {
  const { redirectTo } = Route.useSearch();
  const { error, data } = useSuspenseQuery(GET_TERMS_OF_USE);

  const { onAgreeTerms, agreeTermsMutationError, agreeTermsMutationLoading } =
    useAgreeTermOfUse({ redirectTo: redirectTo });

  if (error) {
    throw error;
  }

  if (agreeTermsMutationError) {
    throw agreeTermsMutationError;
  }

  if (
    data.embaTermsOfUse.agreementState === TermsOfUseAgreementStateEnum.Agreed
  ) {
    return <Navigate to="/" replace={true} />;
  }

  return (
    <>
      <HeadData title="利用規約" />
      <TermsOfServiceContainer
        termsOfUseData={data.embaTermsOfUse}
        onAgreeTerms={onAgreeTerms}
        agreeTermsMutationLoading={agreeTermsMutationLoading}
      />
    </>
  );
}
